module.exports = __webpack_public_path__ + "img/generate-icon.cdbbfe50.svg";